/* ==========================================================================
   Elevate Floors — RODAPÉ

   Três responsabilidades:
     1. syncSpacer()  — a altura do espaçador é MEDIDA, nunca cravada.
     2. glow()        — a textura que segue o cursor. Só desktop.
     3. accordion()   — a coluna de menu no mobile, com compensação de scroll.

   Re-executável: o editor de tema troca o nó da section a cada save e dispara
   shopify:section:load.
   ========================================================================== */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var desktop = window.matchMedia('(min-width: 1025px)');

  function init() {
    var footer = document.querySelector('.ef-footer');
    var spacer = document.querySelector('.ef-foot-spacer');
    if (!footer) return;

    /* ---------- 1. o espaçador acompanha o rodapé -------------------------
       A altura muda com a largura da tela (as colunas reflowam), com o tamanho
       de fonte do sistema e com o acordeão aberto. Um valor cravado em CSS dá
       ou um vão morto ou um rodapé cortado. */
    /* O espaçador é a altura do rodapé MENOS a sobreposição. Com a altura
       cheia, a base da folha para exatamente no topo do rodapé — e aí a curva
       de 22px dela recorta creme sobre creme (o <body> tem
       background:var(--color-background) e o navegador propaga isso para o
       canvas da página, atrás de tudo). Canto arredondado só aparece quando há
       outra cor atrás: descontando a sobreposição, a folha termina POR CIMA do
       rodapé e a curva passa a revelar o gradiente escuro nos dois cantos.

       Por isso o valor tem de ser MAIOR que o raio da curva: com 22px de raio
       e 24px de sobreposição, sobram 2px de folga. */
    function overlap() {
      var v = parseFloat(getComputedStyle(footer).getPropertyValue('--ef-foot-overlap'));
      return isNaN(v) ? 24 : v;
    }

    /* O modo é lido do CSS COMPUTADO, não de um data-attribute: quem manda é o
       bloco de estilo que a section emite conforme a página (ver
       sections/ef-footer.liquid). Assim o JS não precisa saber a regra de
       negócio — ele só pergunta ao navegador se o rodapé está fixo. */
    function revelando() {
      return getComputedStyle(footer).position === 'fixed';
    }

    /* O rodapé fixo é ancorado em bottom:0 e cresce para CIMA. Quando fica mais
       alto que a janela, o excedente sai pelo topo — e não há como alcançá-lo,
       porque position:fixed não rola com a página.

       No celular as quatro colunas empilham e ele chega a ~1000px contra 844 de
       tela: o logo e o texto da marca ficavam cortados SEMPRE, com o acordeão
       aberto ou fechado. Abrir uma coluna só piorava.

       Onde não couber, a revelação é abandonada e o rodapé volta ao fluxo, que
       é onde a página rola e mostra tudo. No desktop e no tablet ele cabe
       folgado (451px em 1440x900), então lá o efeito continua igual.

       A classe vai no <html> porque ela também precisa alcançar a folha, para
       desfazer a curva de 22px que só existe para descobrir o rodapé por baixo. */
    function ajustaEncaixe() {
      var cabe = footer.offsetHeight <= window.innerHeight;
      document.documentElement.classList.toggle('ef-foot-solto', !cabe);
    }

    function syncSpacer() {
      if (!spacer) return;
      // sem revelação não há rolagem a reservar; qualquer altura aqui viraria
      // um vão morto no fim da página
      if (!revelando()) { spacer.style.height = ''; return; }
      spacer.style.height = Math.max(0, footer.offsetHeight - overlap()) + 'px';
    }

    /* Ordem obrigatória: decidir o encaixe ANTES de medir o espaçador. Ao
       contrário, o espaçador seria calculado para um modo que a linha seguinte
       desfaz, e sobraria um vão morto de uma tela inteira. */
    function atualiza() {
      ajustaEncaixe();
      syncSpacer();
    }

    if (footer._efFootRO) footer._efFootRO.disconnect();
    if ('ResizeObserver' in window) {
      footer._efFootRO = new ResizeObserver(atualiza);
      footer._efFootRO.observe(footer);
    } else {
      window.addEventListener('resize', atualiza);
    }
    window.addEventListener('resize', atualiza);
    atualiza();

    /* ---------- 2. a luz que PERSEGUE o cursor ---------------------------
       O mousemove não escreve a posição da luz: ele só guarda o destino. Um
       loop de rAF caminha uma fração da distância a cada frame, e é essa fração
       (EASE) que produz o atraso elástico. Escrever direto no DOM é obrigatório
       aqui — qualquer estado re-renderizado a 60fps trava a página.

       Só no desktop: (hover: none) descarta touch, onde não existe cursor para
       perseguir, e reduced-motion desliga o efeito inteiro. */
    var glow = footer.querySelector('.ef-foot-glow');
    var noHover = window.matchMedia('(hover: none)');

    if (glow && !noHover.matches && !reduce.matches && !footer._efGlowBound) {
      footer._efGlowBound = true;

      // fração da distância por frame: menor = mais arrastado. Vem do customizer.
      var EASE = (parseFloat(glow.getAttribute('data-ease')) || 75) / 1000;

      var tx = null, ty = null;   // destino
      var cx = null, cy = null;   // posição atual
      var raf = null, on = false;

      function step() {
        if (tx === null) { raf = null; return; }
        cx += (tx - cx) * EASE;
        cy += (ty - cy) * EASE;

        // TRÊS paradas (.8 / .32 / 0). Com duas, aparece a borda do círculo.
        var m = 'radial-gradient(420px 420px at ' + cx.toFixed(1) + 'px ' +
                cy.toFixed(1) + 'px, rgba(0,0,0,.8) 0%, rgba(0,0,0,.32) 46%,' +
                ' rgba(0,0,0,0) 76%)';
        glow.style.maskImage = m;
        glow.style.webkitMaskImage = m;

        // O loop se encerra quando a luz alcançou o destino E o mouse já saiu.
        // Sem isto fica um rAF rodando para sempre, gastando bateria na página
        // inteira — o rodapé é fixed e existe em todas as telas.
        var settled = Math.abs(tx - cx) < 0.4 && Math.abs(ty - cy) < 0.4;
        if (settled && !on) { raf = null; return; }
        raf = requestAnimationFrame(step);
      }

      footer.addEventListener('mousemove', function (e) {
        var r = footer.getBoundingClientRect();
        tx = e.clientX - r.left;
        ty = e.clientY - r.top;
        // primeira entrada: a luz NASCE sob o cursor. Sem isto ela vem voando
        // do canto superior esquerdo até ele.
        if (cx === null) { cx = tx; cy = ty; }
        if (!on) { on = true; glow.classList.add('is-on'); }
        if (!raf) raf = requestAnimationFrame(step);
      });

      footer.addEventListener('mouseleave', function () {
        on = false;
        glow.classList.remove('is-on');
      });
    }

    /* ---------- 3. a coluna colapsável -----------------------------------
       O rodapé é fixed e CRESCE PARA CIMA: sem compensar o scroll, a linha que
       a pessoa tocou salta para cima da tela ao abrir. Mede-se a altura antes
       e depois e rola-se a página pela diferença. */
    footer.querySelectorAll('.ef-foot-head[aria-controls]').forEach(function (head) {
      if (head._efFootBound) return;
      head._efFootBound = true;

      head.addEventListener('click', function () {
        if (desktop.matches) return;          // no desktop nunca fecha

        var before = footer.offsetHeight;
        var open = head.getAttribute('aria-expanded') === 'true';
        head.setAttribute('aria-expanded', open ? 'false' : 'true');

        // Rodapé no fluxo cresce para BAIXO: a linha tocada não foge, e
        // compensar o scroll aqui empurraria a página sem motivo.
        if (!revelando()) return;

        // A transição de max-height leva .5s: medir no frame seguinte ainda dá
        // a altura antiga. O loop espera a altura mudar de verdade, aplica e para.
        var tries = 0;
        (function settle() {
          var d = footer.offsetHeight - before;
          if (Math.abs(d) > 1) {
            atualiza();                       // ORDEM IMPORTA: o documento precisa
            window.scrollBy(0, d);            // crescer antes do scroll, senão o
            return;                           // navegador limita o deslocamento.
          }
          if (tries++ < 30) requestAnimationFrame(settle);
        })();
      });
    });

    /* No desktop o corpo está sempre visível; o aria-expanded tem de dizer isso,
       senão o leitor de tela anuncia "recolhido" sobre um conteúdo aberto. */
    function syncAria() {
      footer.querySelectorAll('.ef-foot-head[aria-controls]').forEach(function (head) {
        if (desktop.matches) head.setAttribute('aria-expanded', 'true');
      });
      atualiza();
    }
    syncAria();
    if (desktop.addEventListener) desktop.addEventListener('change', syncAria);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('load', function () {
    var f = document.querySelector('.ef-footer');
    var s = document.querySelector('.ef-foot-spacer');
    if (!f || !s) return;
    // fontes e imagens já assentaram: é aqui que a altura final se conhece
    document.documentElement.classList.toggle('ef-foot-solto', f.offsetHeight > window.innerHeight);
    if (getComputedStyle(f).position !== 'fixed') { s.style.height = ''; return; }
    var o = parseFloat(getComputedStyle(f).getPropertyValue('--ef-foot-overlap'));
    if (isNaN(o)) o = 24;
    s.style.height = Math.max(0, f.offsetHeight - o) + 'px';   // depois das fontes e imagens
  });
})();
